<template>
  <div class="checklist-block-paddings">
    <BaseChecklistFormBlock
      :title="block.title || 'Checklist'"
      :required="block.required"
      :invalid="block.required && pendingItems.length > 0"
    >
      <div
        class="pending-checklist-item"
        v-for="item in pendingItems"
        :key="item._id"
      >
        <div class="pending-checkbox-row">
          <BaseBetaCheckbox :value="false" @input="completeItem(item)">
            {{ item.text }}
          </BaseBetaCheckbox>

          <!-- <div class="qrw-label-md">

          </div> -->
        </div>
      </div>
      <BaseDivider color="border-base-tertiary" v-if="completedItems.length" />
      <div
        class="section-title qrw-text-content-success-primary"
        v-if="completedItems.length"
      >
        <div class="qrw-label-xs bold">
          {{ $t('checklist_report_blocks.completed')}} ({{ completedItems.length }})
        </div>
      </div>
      <ChecklistBlockItem
        v-for="item in completedItems"
        :key="item._id"
        :item="item"
      />
      <BaseDivider color="border-base-tertiary" v-if="uncompletedItems.length" />
      <div
        class="section-title qrw-text-content-error-primary"
        v-if="uncompletedItems.length"
      >
        <div class="qrw-label-xs bold">
          {{ $t('checklist_report_blocks.uncompleted')}} ({{ uncompletedItems.length }})
        </div>
      </div>
      <ChecklistBlockItem
        v-for="item in uncompletedItems"
        :key="item._id"
        :item="item"
      />
      <BaseDivider color="border-base-tertiary" v-if="notApplicableItems.length" />
      <div
        class="section-title qrw-text-content-base-secondary"
        v-if="notApplicableItems.length"
      >
        <div class="qrw-label-xs bold">
          {{ $t('checklist_report_blocks.not_applicable')}} ({{ notApplicableItems.length }})
        </div>
      </div>
      <ChecklistBlockItem
        v-for="item in notApplicableItems"
        :key="item._id"
        :item="item"
      />
    </BaseChecklistFormBlock>

  </div>
</template>

<script>
import BaseChecklistFormBlock from "./BaseChecklistFormBlock.vue";

import ChecklistBlockItem from "./ChecklistBlockItem.vue";

export default {
  components: {
    BaseChecklistFormBlock,
    ChecklistBlockItem,
  },
  props: {
    block: Object,
    form: Object,
    metadata: Object
  },
  data() {
    return {

    };
  },
  computed: {
    pendingItems() {
      return this.items.filter((it) => it.status === "none" || !it.status);
    },
    completedItems() {
      return this.items.filter((it) => it.status === "completed");
    },
    uncompletedItems() {
      return this.items.filter((it) => it.status === "uncompleted");
    },
    notApplicableItems() {
      return this.items.filter((it) => it.status === "not_applicable");
    },
    items() {
      return this.block.checklist.rows;
    },
  },
};
</script>

<style scoped>
.checklist-block-paddings {
  display: flex;
  padding: 12px 16px;
  width: 100%;
  box-sizing: border-box;
  justify-content: center;
}

.pending-checklist-item {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  padding: 4px;
  width: 100%;
  box-sizing: border-box;
}

.pending-checkbox-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 12px;
  width: 100%;
  box-sizing: border-box;
}

.section-title {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  padding: 8px 10px;
}
</style>
